import { ContentSchema } from '../../../definitions/schemas';
import { StorageProviderMTPickers } from '../../../enums/Integrations/StorageProviders';

const ContentRemovalReason = {
  ARCHIVED: 'room.overview.content.removed.asset_archived_description',
  ASSET_REMOVED: 'room.overview.content.asset.removed.from_room',
  DELETED_FROM_LIBRARY: 'room.overview.content.removed.from_library',
  DELETED: 'room.overview.content.removed.asset_deleted_description',
  INTERNAL: 'room.overview.content.removed.asset_internal_description',
  REMOVED: 'room.overview.content.removed.from_room',
};

const ContentRemovalOverviewReason = {
  ARCHIVED: 'asset_archived_title',
  DELETED: 'asset_deleted_title',
  INTERNAL: 'asset_internal_title',
  REMOVED: 'asset_removed_title',
};

const ContentRemovalShortReason = {
  ARCHIVED: 'room.overview.content.removed.asset_archived_title',
  ASSET_REMOVED: 'room.overview.content.asset.removed.title',
  CONTENT_DELETED: 'room.overview.content.deleted.title',
  DELETED: 'room.overview.content.removed.asset_deleted_title',
  INTERNAL: 'room.overview.content.removed.asset_internal_title',
  REMOVED: 'room.overview.content.removed.title',
};

export const extractSharableIdFromUrl = (url: string): string | null => {
  const regex = /\/sh\/(\d+)\//;
  const match = url.match(regex);
  return match ? match[1] : null;
};

export const extractContentIdFromUrl = (url: string): string | null => {
  const urlObj = new URL(url);
  const contentId = urlObj.searchParams.get('id');
  return contentId ?? null;
};

export const getRemovalReason = (content: Partial<ContentSchema>) => {
  const { deletedAt, isArchived, isInternal, mtData } = content;
  const isAssetHubContent =
    mtData?.provider === StorageProviderMTPickers.AssetHub;

  const processAssetHubContentRemovalReason = (messages: {
    DELETED: string;
    ARCHIVED: string;
    INTERNAL: string;
    ASSET_REMOVED: string;
  }) => {
    if (deletedAt) return messages.DELETED;
    if (isArchived) return messages.ARCHIVED;
    if (isInternal) return messages.INTERNAL;

    return messages.ASSET_REMOVED;
  };

  return {
    getDescription: () => {
      if (isAssetHubContent) {
        return processAssetHubContentRemovalReason(ContentRemovalReason);
      }
      return deletedAt
        ? ContentRemovalReason.DELETED_FROM_LIBRARY
        : ContentRemovalReason.REMOVED;
    },
    getTitle: () => {
      if (isAssetHubContent) {
        return processAssetHubContentRemovalReason(ContentRemovalShortReason);
      }

      return deletedAt
        ? ContentRemovalShortReason.CONTENT_DELETED
        : ContentRemovalShortReason.REMOVED;
    },

    getOverviewReason: () => {
      if (isAssetHubContent) {
        return processAssetHubContentRemovalReason({
          ...ContentRemovalOverviewReason,
          ASSET_REMOVED: ContentRemovalOverviewReason.REMOVED,
        });
      }

      return deletedAt
        ? ContentRemovalOverviewReason.DELETED
        : ContentRemovalOverviewReason.REMOVED;
    },
  };
};
